module.exports = __webpack_public_path__ + "static/media/TransportesSantaJuana-Trabaja-con-nosotros-Imagen-2.f0243eee.webp";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/santajuana/TransportesSantaJuana-Trabaja-con-nosotros-Imagen-2.webp
// module id = 1685
// module chunks = 0